export interface McpToolAvailabilityServer {
  source?: 'platform' | 'external'
  installed?: boolean
}

export function pruneUnavailableServerTools<TTools>(
  servers: Record<string, McpToolAvailabilityServer>,
  tools: Record<string, TTools>
): Record<string, TTools> {
  const availableServerIds = new Set(
    Object.entries(servers)
      .filter(([, server]) => server.source !== 'external' || server.installed === true)
      .map(([serverId]) => serverId)
  )

  return Object.fromEntries(Object.entries(tools).filter(([serverId]) => availableServerIds.has(serverId)))
}
